module.exports = "<div class=\"maximize\"><ul class=\"nav nav-list panel-dark filters-list\"><sc-catalog-node ng-repeat=\"filter in $ctrl.filters\" filter=\"filter\"></sc-catalog-node></ul></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/catalog/catalog.component.html
// module id = 278
// module chunks = 0